import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../../../app/store";

export interface DrawerState {
  openDrawer: boolean;
  drawerItem: {
    open?: boolean;
    name?: string;
  };
}

const initialState: DrawerState = {
  openDrawer: false,
  drawerItem: {
    open: false,
    name: "",
  },
};

export const drawerSlice = createSlice({
  name: "drawer",
  initialState,
  reducers: {
    drawerOpenAndCloseAction: (state) => {
      state.openDrawer = !state.openDrawer;
    },

    drawerOpenOrCloseAction: (state, action: PayloadAction<boolean>) => {
      state.openDrawer = action.payload;
    },

    drawerItemOpenAndCloseAction: (
      state,
      action: PayloadAction<string>
    ) => {
      state.drawerItem = {
        open:
          action.payload === state.drawerItem.name
            ? !state.drawerItem.open
            : true,
        name: action.payload,
      };
    },

    drawerItemOpenOrCloseAction: (state, action: PayloadAction<object>) => {
      state.drawerItem = action.payload;
    },
  },
});

export const {
  drawerOpenAndCloseAction,
  drawerOpenOrCloseAction,
  drawerItemOpenAndCloseAction,
  drawerItemOpenOrCloseAction,
} = drawerSlice.actions;

export const drawer = (state: RootState) => state.drawerState;

export default drawerSlice.reducer;
